export class ChangePasswordRequest {
  Email: string = '';
  CurrentPassword: string = '';
  NewPassword: string = '';
}
